import { render, staticRenderFns } from "./ekle.vue?vue&type=template&id=c2223e98&"
import script from "./ekle.vue?vue&type=script&lang=js&"
export * from "./ekle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports